export const VISITOR_ID_COOKIE_KEY = 'cm_visitor_id';

export const VISITOR_ID_COOKIE_MAX_AGE_SECONDS: number = 60 * 60 * 24 * 30;
